$(function () {
  if (!customElements.get('home-swiper')) {
    customElements.define(
      'home-swiper',
      class HomeSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }
        animateText($elements) {
          $elements.each(function (index) {
            const $this = $(this);
            setTimeout(function () {
              $this.css({
                opacity: 1,
                transform: 'translateY(0) translateZ(0)',
                transition: 'opacity .6s linear .3s,transform .6s cubic-bezier(.215,.61,.355,1) .3s',
              });
            }, index * 100);
          });
        }
        init() {
          const self = this;
          const root = $(this);
          const $slides = root.find('.swiper-slide');
          if ($slides.length === 0) return;
          if ($slides.length > 1) {
            const initSwiper = () => {
              const swiperEle = root.find('.home-swiper')[0];
              const $pagination = root.find('.swiper-pagination');
              const mySwiper = new Swiper(swiperEle, {
                loop: true,
                effect: 'fade',
                speed: 600,
                fadeEffect: {
                  crossFade: true,
                },
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: false,
                  type: 'bullets',
                },
                preloadImages: false,
                lazy: {
                  loadPrevNext: true,
                  loadPrevNextAmount: 1,
                  loadOnTransitionStart: true,
                },
                on: {
                  init: function () {
                    const $elements = $(this.slides[0]).find('.home-swiper__text');
                    self.animateText($elements);

                    setTimeout(() => {
                      $pagination.find('.swiper-pagination-bullet-active').addClass('home-swiper-pagination-bullet__active')
                    }, 0)
                  },
                  slideChangeTransitionStart: function () {
                    const $previousIndex = $(this.slides[this.previousIndex]);
                    $previousIndex.find('.home-swiper__text').css({
                      opacity: 0,
                      transform: 'translateY(-60px)',
                      transition: 'none',
                    });

                    const $currentIndex = $(this.slides[this.activeIndex]);
                    const $elements = $currentIndex.find('.home-swiper__text');
                    self.animateText($elements);

                    $pagination.find('.swiper-pagination-bullet').removeClass('home-swiper-pagination-bullet__active');
                    $pagination.find('.swiper-pagination-bullet-active').addClass('home-swiper-pagination-bullet__active');

                    // 切换头部导航主题
                    const theme = $(this.slides[this.activeIndex]).attr('data-theme');
                    $('#lt-header').attr('data-theme', theme);
                  }
                }
              });
            };
            initSwiper();
          } else {
            const $elements = $slides.find('.home-swiper__text');
            self.animateText($elements);
          }
        }
      }
    );
  }
});
